import type { GateType } from './SignalState';

export const PIN_MAP = {
  inputA: 1,
  inputB: 2,
  outputY: 3,
  gnd: 7,
  vcc: 14
} as const;

export const CHIP_MODEL: Record<GateType, string> = {
  AND: '74HC08N',
  NAND: '74HC00N',
  OR: '74HC32N'
};
